import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {EventRegistrationComponent} from './event-registration.component';

const routes: Routes = [
  {path: 'register/:company_name', component: EventRegistrationComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class EventRegistrationRoutingModule { }
